module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGad012be3c5700f165e16210a18104926.ad012be3.png";